import { ProfileVerifyEmailPage } from '@/app/pages/profile/profile-verify-email-page';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

export const Route = createFileRoute('/profile/verify-email')({
  validateSearch: z.object({
    newEmail: z.string(),
  }),
  component: ProfileVerifyEmailPage,
});
